<template>
  <div v-if="value">
    <div class="flex-row full-size">
      <PropertyCard
        group="DIM"
        color="purple"
        icon="fa fa-list"
        title="Dimensions"
        :value="value" />
      <PropertyCard
        :small-icon="false"
        group="MEZ"
        color="green"
        icon="functions"
        title="Measures"
        :value="value" />
    </div>
    <PropertyCard
      style="height: 220px"
      group="FILTER"
      color="red"
      icon=" fas fa-filter"
      title="Filters"
      :value="value" />
  </div>
</template>

<script>
import PropertyCard from './PropertyCard'
export default {
  components: { PropertyCard },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~common-assets/scss/we";
</style>
